module.exports = __webpack_public_path__ + "img/xtts.b67cd868.png";